import React, { useState } from "react";
import { Input as AntInput, InputContainer } from "./FloatLabelInput.style";

const FloatLabelInput = (props) => {
  const [focus, setFocus] = useState(false);
  let { Input = AntInput, label, value, placeholder, type, required, ..._props } = props;

  if (!placeholder) placeholder = label;

  const isOccupied = focus || (value && value.length !== 0);

  const labelClass = isOccupied ? "label as-label" : "label as-placeholder";

  const requiredMark = required ? <span className="text-danger">*</span> : null;

  return (
    <InputContainer
      className="float-label"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      <Input onChange={props.onChange} type={type} value={value} {..._props} />
      <label className={labelClass}>
        {isOccupied ? label : placeholder} {requiredMark}
      </label>
    </InputContainer>
  );
};

export default FloatLabelInput;
